import { useCallback } from 'react';

import { Badge, Icon } from '@mui/material';

import { NotificationIcon } from '@components/icons/notification';
import type { MenuExtendedItem } from '@components/sidebar/types';

import { useApp } from '@system/app';

export const SidebarFooterMenuStart = (): MenuExtendedItem[] => {
  const { notificationUI, flags } = useApp();
  const { newCount } = notificationUI.use();

  const handleClick = useCallback(() => {
    notificationUI.toggle();
  }, [notificationUI]);

  const maintenance_mode = flags?.find(
    item => item.name === 'maintenance_mode',
  );
  const isMaintenanceMode = maintenance_mode?.value === 'on';

  return [
    {
      title: isMaintenanceMode
        ? 'Включен режим технических работ'
        : 'Уведомления',
      icon: (
        <Icon
          color="inherit"
          sx={{
            width: '100%',
            height: '100%',
            cursor: 'pointer',
          }}
        >
          <Badge
            badgeContent={newCount}
            color="error"
            sx={{
              '& .MuiBadge-badge': {
                fontSize: 10,
                height: 13,
                minWidth: 12,
                right: 12,
              },
            }}
          >
            <NotificationIcon color={isMaintenanceMode ? 'error' : 'inherit'} />
          </Badge>
        </Icon>
      ),
      handleClick,
    },
  ];
};
